import * as React from 'react'

function SvgIconFingerprint(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="0 0 32 32" width="1em" height="1em" {...props}>
      <g id="fingerprint" aria-labelledby="t-fingerprint d-fingerprint">
        <title id="t-fingerprint">{'Fingerprint'}</title>
        <desc id="d-fingerprint">
          {'Impression left by the friction ridges of a human finger'}
        </desc>
        <path d="M13.4 31.1c-.1 0-.2 0-.3-.1C9.9 28.3 8 24.2 8 20c0-4.1 3.4-7.5 7.5-7.5S23 15.9 23 20c0 .3-.2.5-.5.5s-.5-.2-.5-.5c0-3.6-2.9-6.5-6.5-6.5S9 16.4 9 20c0 4 1.7 7.7 4.7 10.3.2.2.2.5.1.7-.1.1-.2.1-.4.1z" />
        <path d="M22.5 27.5c-4.1 0-7.5-3.4-7.5-7.5 0-.3.2-.5.5-.5s.5.2.5.5c0 3.6 2.9 6.5 6.5 6.5.6 0 1.2-.1 1.7-.2.3-.1.5.101.6.3.101.2-.1.5-.3.604-.6.196-1.3.296-2 .296zm5.3-13.7c-.2 0-.3-.1-.399-.3-2.396-4.3-6.896-7-11.896-7-4.1 0-7.9 1.8-10.5 5-.2.2-.5.2-.7.1-.2-.2-.2-.5-.1-.7C7 7.5 11.1 5.5 15.5 5.5c5.3 0 10.2 2.9 12.7 7.6.1.2 0 .5-.2.7h-.2z" />
        <path d="M19.9 30.7h-.1c-4.9-1.2-8.3-5.601-8.3-10.7 0-2.2 1.8-4 4-4s4 1.8 4 4c0 1.7 1.3 3 3 3s3-1.3 3-3c0-5.5-4.5-10-10-10s-10 4.5-10 10c0 .8.1 1.6.2 2.4 0 .3-.2.5-.4.6-.3 0-.5-.2-.6-.4-.1-.8-.2-1.699-.2-2.5 0-6.1 4.9-11 11-11s11 4.9 11 11c0 2.2-1.8 4-4 4s-4-1.8-4-4c0-1.699-1.3-3-3-3s-3 1.301-3 3c0 4.604 3.1 8.604 7.5 9.7.3.101.4.3.4.601-.1.099-.3.299-.5.299zm3.9-25.6c-.1 0-.2 0-.2-.1-4.3-2.3-9.6-2.6-14.2-.9-.3.1-.5 0-.6-.3-.2-.2-.1-.5.2-.6 4.8-1.9 10.5-1.5 15 .9.2.1.3.4.2.7-.1.2-.3.3-.4.3z" />
      </g>
    </svg>
  )
}

export default SvgIconFingerprint
